export const iconFontAwesomeToggleBullseye = (
	<i className="fa-solid fa-bullseye"></i>
);
